import type { Options } from '@popperjs/core';

/** DS gap between a dropdown trigger and its panel (Figma 1983:12968). */
export const ANC_DROPDOWN_GAP = 8;

/**
 * ng-bootstrap positions dropdown panels 2px off their trigger; the DS asks for
 * 8px. Popper merges modifiers by name and the last one wins, so appending ours
 * overrides the built-in offset without having to fork the positioning service.
 *
 * Bind on any `ngbDropdown`: `[popperOptions]="popperOptions"`.
 */
export const ancDropdownPopperOptions = (
    options: Partial<Options>
): Partial<Options> => {
    options.modifiers = [
        ...(options.modifiers ?? []),
        { name: 'offset', options: { offset: () => [0, ANC_DROPDOWN_GAP] } }
    ];
    return options;
};
